var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTv = function SvgTv(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.675 19-.55 1.65a.53.53 0 0 1-.175.25.47.47 0 0 1-.3.1H4.5a.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35V19q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 17V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v11q0 .824-.587 1.413A1.93 1.93 0 0 1 20 19v1.525a.46.46 0 0 1-.137.338.46.46 0 0 1-.338.137h-.175a.47.47 0 0 1-.45-.325L18.35 19zM4 17h16V6H4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTv);
export { ForwardRef as ReactComponent };